import React from 'react';
import { ProductMasterData } from '../../../../../types/product_master_data/productMasterData';

interface ProductMasterDataDropdownItemProps {
  productMasterData?: ProductMasterData;
}

export default function ProductMasterDataDropdownItem({ productMasterData }: ProductMasterDataDropdownItemProps) {
  return (
    <div>
      <p className='text-sm font-semibold'>{productMasterData?.productName}</p>
      <p className='text-xs text-gray-400'>{productMasterData?.productNumber}</p>
    </div>
  );
}
